export default __webpack_public_path__ + "static/media/activityitem.6c071012.png";